import { createSelector } from '@ngrx/store';

import { selectLiveEdgeState } from './live-edge-base.selectors';

export const galleryState = createSelector(selectLiveEdgeState, state => state.galleryView);
export const getLiveGallerySelectedTab = createSelector(galleryState, state => state.selectedTab);
